import IconButton from "@mui/material/IconButton";

export default function EditButton({
  ariaLabel,
  isEditing,
  onClick,
  primaryIcon,
  secondaryIcon,
}) {
  return (
    <IconButton
      aria-label={ariaLabel}
      color="secondary"
      onClick={onClick}
      size="large"
    >
      {isEditing && secondaryIcon ? secondaryIcon : primaryIcon}
    </IconButton>
  );
}
